import React from 'react';
import topBanner from '../Assets/img/topBanner.png';
import { Link } from 'react-router-dom';

const ShippingandDelivery = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <Link to={`/`} className='btn btn-success btn-sm'>
            <img src={topBanner} alt='Banner' style={{ width: '100%' }} />
          </Link>
        </div>
      </div>

      <div className='container mt-4'>
        <h2>Shipping & Delivery Policy</h2>
        <p>
          At <strong>Juice@Home</strong>, we ensure your fresh juice is prepared on the day of delivery and reaches you as quickly and safely as possible.
        </p>

        <h5 className="mt-3">Delivery Coverage</h5>
        <ul>
          <li>Currently, we serve select apartment complexes and gated communities in Pune, Maharashtra.</li>
          <li>If your location is not listed, feel free to contact us to check availability or upcoming service expansion.</li>
        </ul>

        <h5 className="mt-4">Delivery Schedule</h5>
        <ul>
          <li>Orders placed before 8 PM are eligible for next-day morning delivery (between 7 AM and 10 AM).</li>
          <li>Same-day delivery is not guaranteed due to fresh production requirements.</li>
          <li>Our delivery partners ensure contactless delivery for your safety and convenience.</li>
        </ul>

        <h5 className="mt-4">Delivery Charges</h5>
        <ul>
          <li>Free delivery on orders above ₹200.</li>
          <li>A nominal delivery charge of ₹20 applies to orders below ₹200.</li>
        </ul>

        <h5 className="mt-4">Missed Deliveries</h5>
        <ul>
          <li>If our delivery executive is unable to reach you, the product will not be redelivered as juices are made fresh and perishable.</li>
          <li>No refunds are applicable for missed deliveries unless there is an error on our part.</li>
        </ul>

        <p className="mt-3">
          For any delivery-related queries or support, please contact us at <strong>info@erelatelabs.com</strong> or call <strong>+91-9284773653</strong>.
        </p>
      </div>
    </>
  );
};

export default ShippingandDelivery;
